module.exports = __webpack_public_path__ + "static/media/34.b037036d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/34.png
// module id = 995
// module chunks = 0